import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class TopCard {
  constructor(options) {
    const _ = this;
    if (!options) return;
    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window,
      apiDomain: '',
      data : null
    }, options);
    _.global = (_.option.global) ? _.option.global : window;
    _.isLogin = _.global.userData.isLogin;
    _.noticeWrap = $('.wrap-section-notice');
  }

  init() {
    const _ = this;
    console.log( '# topCard.js init() _.option : ', _.option);

    // if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();
    _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;
    console.log( '# topCard.js setInstance() : _.option.data : ', _.option.data);
    // 2번 카드
    let item0 = _.option.data.items[0];
    let tmplTopcard2 = `
        <section class="section-topcard section-topcard2">
          <header><h2><a href="${item0.headerUrl}">${item0.header}</a></h2></header>
          <article>
              <a href="${item0.url}">
                  <dl><dd class="thumb" style="background-image:url('${item0.thumbnail}');"><img src="${item0.thumbnail}" class="thumb"></dd>
                  <dt>${item0.title}</dt>
                  <dd class="desc">${item0.desc}</dd>
                  </dl>
              </a>
          </article>
        </section>
      `;

    // 3, 4번 카드
    let tmpl = _.option.data.items.map( (item, i) => {
        if(i > 0 ) {
        return `
          <section class="section-topcard section-topcard${i+2}">
          <header><h2><a href="${item.headerUrl}">${item.header}</a></h2></header>
          <article>
              <a href="${item.url}">
                  <dl><dd class="thumb" style="background-image:url('${item.thumbnail}');"><img src="${item.thumbnail}" class="thumb"></dd>
                  <dt>${item.title}</dt>
                  <dd class="desc">${item.desc}</dd>
                  </dl>
              </a>
          </article>
        </section>
        `;
        }
    }).join('');

    if(! _.isLogin ) {
      _.option.wrap.append(tmpl);
    }
    _.noticeWrap.append(tmplTopcard2);
    _.addEvent();

  }
  addEvent() {
    const _ = this;
    _.noticeWrap.slick({
      dots: true,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 4000,
          settings: "unslick"
        },
        {
          breakpoint: 640,
          slidesToShow: 1
        }
      ]
    });
    if(! _.isLogin ) {
      _.option.wrap.slick({
        dots: true,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 4000,
            settings: "unslick"
          },
          {
            breakpoint: 640,
            slidesToShow: 1
          }
        ]
      });
    }
    $(window).resize(function() {
      _.noticeWrap.slick('resize');
      if(! _.isLogin) _.option.wrap.slick('resize');
    });
  }

}

export default TopCard;


// WEBPACK FOOTER //
// ./_src/js/main/content/TopCard.js